import React, { useState, useEffect } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import axios from "axios";
import { HomePage } from "./components/Pages/HomePage";
import { AdminPage } from "./components/Pages/AdminPage";
import { Dashboard } from "./components/Pages/DashBoard";
import LearnMore from "./components/Pages/LearnMore"

// Cookie Consent Banner Component
function CookieConsentBanner({ onAccept }) {
  return (
    <div className="cookie-banner">
      <p>
        This application uses cookies—including 3rd party cookies—for login and proper functionality.
        Please accept cookies to continue.
      </p>
      <button onClick={onAccept}>Accept Cookies</button>
    </div>
  );
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [userData, setUserData] = useState(null);
  const [cookieConsent, setCookieConsent] = useState(() => {
    return document.cookie.indexOf("cookieConsent=true") !== -1;
  });

  // Run the authentication and optional OTP clearance only if cookies have been accepted.
  useEffect(() => {
    if (!cookieConsent) return;

    const checkAuth = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/check_auth`,
          { withCredentials: true }
        );
        if (response.data.success) {
          setUserData(response.data.user);
          setIsLoggedIn(true);
        } else {
          setIsLoggedIn(false);
          setUserData(null);
        }
      } catch (error) {
        console.error("Authentication check failed:", error);
        setIsLoggedIn(false);
        setUserData(null);
      }
    };

    const clearExpiredOtps = async () => {
      try {
        await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/api/nullify_otp`,
          { withCredentials: true }
        );
      } catch (error) {
        console.error("Error clearing OTPs:", error);
      }
    };

    checkAuth();
    // clearExpiredOtps();

    const interval = setInterval(() => {
      checkAuth();
      // clearExpiredOtps();
    }, 600000);

    return () => clearInterval(interval);
  }, [cookieConsent]);

  // Handler for accepting cookies.
  const handleAcceptCookies = () => {
    // Set cookieConsent cookie for 1 year with attributes to enable third-party cookies.
    document.cookie =
      "cookieConsent=true; path=/; max-age=" +
      60 * 60 * 24 * 365 +
      "; SameSite=None; Secure";
    setCookieConsent(true);
  };

  return (
    <Router>
      <div className="app-container">
        {/* Render the Cookie Consent Banner if cookies have not yet been accepted */}
        {!cookieConsent && !isLoggedIn && <CookieConsentBanner onAccept={handleAcceptCookies} />}
        
        {/* Existing header component (currently commented out) */}
        {/* {isLoggedIn && (
          <Header
            isLoggedIn={isLoggedIn}
            setIsLoggedIn={setIsLoggedIn}
            userData={userData}
            setUserData={setUserData}
          />
        )} */}
        
        <Routes>
          <Route
            path="/"
            element={
              <HomePage
                isLoggedIn={isLoggedIn}
                setIsLoggedIn={setIsLoggedIn}
                userData={userData}
                setUserData={setUserData}
              />
            }
          />
          <Route
            path="/home"
            element={
              <HomePage
                isLoggedIn={isLoggedIn}
                setIsLoggedIn={setIsLoggedIn}
                userData={userData}
                setUserData={setUserData}
              />
            }
          />
          <Route
            path="/dashboard"
            element={
              isLoggedIn && userData ? (
                <Dashboard
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}
                  userData={userData}
                  setUserData={setUserData}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/admin"
            element={
              isLoggedIn && userData?.Role.includes("Admin") ? (
                <AdminPage
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}
                  userData={userData}
                  setUserData={setUserData}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route
            path="/learn-more"
            element={
              isLoggedIn && userData ? (
                <LearnMore
                  isLoggedIn={isLoggedIn}
                  setIsLoggedIn={setIsLoggedIn}
                  userData={userData}
                  setUserData={setUserData}
                />
              ) : (
                <Navigate to="/" />
              )
            }
          />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;